export default {
    methods: {
        align  (column) {
            switch (column.type) {
                case "String":
                    return "text-align: left;"
                case "Date":
                    return "text-align: center;"
                case "Money":
                    return "text-align: right;"
            }

            return "text-align: left;"
        },

        width (column) {
            return "width: " + column.width + "px; max-width" + column.width + "px;" + this.align(column);
        },

        valueWidth (index) {
            const column = this.columns[index];
            return this.width(column);
        },
    }
}